<template>
  <div class="title-tips">
    <div class="title">
      {{ title }}
    </div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item, index) in routeList" :key="index">{{
        item.meta.title
      }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    title: {
      type: String,
      default: '主题名称'
    },
    routerList: {
      type: Array,
      default: () => []
    },
    routeType: {
      type: String,
      default: '/gywm/companyIntroduction'
    }
  },
  data() {
    return {
      routeList: [],
      config: {
        '/gywm/companyIntroduction': [
          {
            path: '/gywm/companyIntroduction',
            name: 'companyIntroduction',
            meta: {
              title: '关于我们'
            }
          },
          {
            path: '/gywm/companyIntroduction',
            name: 'companyIntroduction',
            meta: {
              title: '公司介绍'
            }
          }
        ],
        '/gywm/organizationalStructure': [
          {
            path: '/gywm/organizationalStructure',
            name: 'companyIntroduction',
            meta: {
              title: '关于我们'
            }
          },
          {
            path: '/gywm/organizationalStructure',
            name: 'companyIntroduction',
            meta: {
              title: '组织架构'
            }
          }
        ],
        '/gywm/qualityCommitment': [
          {
            path: '/gywm/qualityCommitment',
            name: 'companyIntroduction',
            meta: {
              title: '关于我们'
            }
          },
          {
            path: '/gywm/qualityCommitment',
            name: 'companyIntroduction',
            meta: {
              title: '质量承诺'
            }
          }
        ],
        '/gywm/developmentHistory': [
          {
            path: '/gywm/developmentHistory',
            name: 'companyIntroduction',
            meta: {
              title: '关于我们'
            }
          },
          {
            path: '/gywm/developmentHistory',
            name: 'companyIntroduction',
            meta: {
              title: '发展历程'
            }
          }
        ],
        '/news/industryNews': [
          {
            path: '/news/industryNews',
            name: 'companyIntroduction',
            meta: {
              title: '信息公开'
            }
          }
        ],

        '/gywm/honoraryQualification': [
          {
            path: '/gywm/honoraryQualification',
            name: 'companyIntroduction',
            meta: {
              title: '关于我们'
            }
          },
          {
            path: '/gywm/honoraryQualification',
            name: 'companyIntroduction',
            meta: {
              title: '资质荣誉'
            }
          }
        ],
        '/news/companyNews': [
          {
            path: '/news/companyNews',
            name: 'companyIntroduction',
            meta: {
              title: '新闻中心'
            }
          },
          {
            path: '/news/companyNews',
            name: 'companyIntroduction',
            meta: {
              title: '公司新闻'
            }
          }
        ],
        '/news': [
          {
            path: '/news',
            name: 'companyIntroduction',
            meta: {
              title: '新闻中心'
            }
          }
        ],
        '/news/publicAnnouncement': [
          {
            path: '/news/publicAnnouncement',
            name: 'companyIntroduction',
            meta: {
              title: '新闻中心'
            }
          },
          {
            path: '/news/publicAnnouncement',
            name: 'companyIntroduction',
            meta: {
              title: '公示公告'
            }
          }
        ],
        '/newsDetail': [
          {
            path: '/newsDetail',
            name: 'companyIntroduction',
            meta: {
              title: '新闻中心'
            }
          },
          {
            path: '/newsDetail',
            name: 'companyIntroduction',
            meta: {
              title: '新闻详情'
            }
          }
        ],

        '/productDetail': [
          {
            path: '/productDetail',
            name: 'companyIntroduction',
            meta: {
              title: '产品展示'
            }
          },
          {
            path: '/productDetail',
            name: 'companyIntroduction',
            meta: {
              title: '产品详情'
            }
          }
        ],
        '/humanResource/employmentConcept': [
          {
            path: '/humanResource/employmentConcept',
            name: 'companyIntroduction',
            meta: {
              title: '人力资源'
            }
          },
          {
            path: '/humanResource/employmentConcept',
            name: 'companyIntroduction',
            meta: {
              title: '用人理念'
            }
          }
        ],
        '/humanResource/recruitmentInformation': [
          {
            path: '/humanResource/recruitmentInformation',
            name: 'companyIntroduction',
            meta: {
              title: '人力资源'
            }
          },
          {
            path: '/humanResource/recruitmentInformation',
            name: 'companyIntroduction',
            meta: {
              title: '招聘信息'
            }
          }
        ],
        '/connectUs': [
          {
            path: '/connectUs',
            name: 'companyIntroduction',
            meta: {
              title: '联系我们'
            }
          }
        ],
        '/showProduct': [
          {
            path: '/showProduct',
            name: 'showProduct',
            meta: {
              title: '服务产品'
            }
          }
        ]
      }
    };
  },
  created() {
    const productList = JSON.parse(localStorage.getItem('productList') || '[]');

    // '/showProduct/electromechanicalComponents': [
    //   {
    //     path: '/showProduct/electromechanicalComponents',
    //     name: 'companyIntroduction',
    //     meta: {
    //       title: '产品展示'
    //     }
    //   },
    //   {
    //     path: '/showProduct/electromechanicalComponents',
    //     name: 'companyIntroduction',
    //     meta: {
    //       title: '机电元件及组件'
    //     }
    //   }
    // ],
    productList.forEach(p => {
      this.config[`/showProduct/${p.code}`] = [
        {
          path: `/showProduct/${p.code}`,
          name: 'companyIntroduction',
          meta: {
            title: '产品展示'
          }
        },
        {
          path: `/showProduct/${p.code}`,
          name: 'companyIntroduction',
          meta: {
            title: p.name
          }
        }
      ];
    });
    this.routeList = this.config[this.routeType];
  },
  watch: {
    routeType(newV, oldV) {
      if (newV != oldV) {
        this.routeList = this.config[newV];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title-tips {
  box-sizing: border-box;
  padding-bottom: 0.15rem;
  padding-right: 0.7rem;
  width: 100%;
  height: 0.7rem;
  margin-bottom: 0.2rem;
  border-bottom: 0.1px solid #999;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .title {
    font-size: 0.18rem;
    font-weight: 700;
    color: #555;
  }
}
</style>
